import { ReactElement, useMemo } from 'react';

import { useHandlePaymentMethod } from '../hooks/useHandlePaymentMethod';

import icTicket from '@/assets/ic_ticket.svg';
import { Button, Card, Tags } from '@/components';
import { useIsLastMatchDay } from '@/hooks/useIsLastMatchDate';
import { TipoProductoTO } from '@/types/myAccount';
import { PACKS_BY_ID, PACKS_BY_NAME } from '@/utils';
import { cn, formatNumberToLocale } from '@/utils/functions';

export const PinsCard = ({ product }: { product: TipoProductoTO }) => {
  const { handlePaymentMethod } = useHandlePaymentMethod();
  const isLastMatchday = useIsLastMatchDay();

  const isTickets = product.id === PACKS_BY_ID[PACKS_BY_NAME.PRINTED_TICKETS];
  const offer40 = product.id === PACKS_BY_ID[PACKS_BY_NAME.PACK_35];
  const offer30 = product.id === PACKS_BY_ID[PACKS_BY_NAME.PACK_20];
  const offer20 = product.id === PACKS_BY_ID[PACKS_BY_NAME.PACK_12];
  const isDisabled = product.isDisabled || false;

  const tagOffer: ReactElement | null = useMemo(() => {
    if (offer20) {
      return <Tags.Alert statusId={103}>Ahorrás 10%</Tags.Alert>;
    } else if (offer30) {
      return <Tags.Alert statusId={104}>Ahorrás 20%</Tags.Alert>;
    } else if (offer40) {
      return (
        <Tags.Alert className="!bg-[#f1dfff] !text-[#9a00f7]" statusId={0}>
          Ahorrás 40%
        </Tags.Alert>
      );
    }
    return null;
  }, [offer20, offer30, offer40]);

  const handleClick = () =>
    isTickets
      ? (window.location.href = '#hash-map')
      : handlePaymentMethod({ product });

  return (
    <Card
      className={cn(
        'bg-white w-[47%] md:w-[32%] lg:w-[203px] h-[172px] lg:h-[270px] border-gdt-gray-6 border-[1px] p-0 flex flex-col items-center pt-3.5 lg:pt-7 text-gdt-gray ',
        {
          'lg:pt-3': isTickets,
          'hover:shadow-btn cursor-pointer': !isDisabled && !isLastMatchday,
        }
      )}
      handleClick={isDisabled || isLastMatchday ? undefined : handleClick}
    >
      {isTickets && (
        <figure>
          <img alt="Icono de ticket impreso" src={icTicket} />
        </figure>
      )}
      <p
        className={cn('text-2xs lg:text-sm font-bold h-4 mb-1 lg:mb-5', {
          'lg:h-auto lg:-mb-3 relative lg:top-3': isTickets,
        })}
      >
        {product.descripcion === 'Pin' ? '1 PIN' : product.descripcion}
      </p>
      {tagOffer && tagOffer}
      <p
        className={cn('text-2xl lg:text-3xl font-bold mb-4 mt-2 lg:mt-6', {
          'mt-7 lg:mt-11': !tagOffer,
        })}
      >
        ${formatNumberToLocale(product.precio)}
      </p>
      <Button
        className="w-20 lg:w-28 h-7 lg:h-10 p-0 text-xs lg:text-sm lg:mt-4"
        disabled={isDisabled || isLastMatchday}
        type="button"
        variant="primary"
        onClick={handleClick}
      >
        {!isTickets ? (
          'Obtener'
        ) : (
          <a
            className="h-full w-full flex items-center justify-center"
            href={isDisabled || isLastMatchday ? undefined : '#hash-map'}
          >
            Ver dónde
          </a>
        )}
      </Button>
      {product.cantidad && product.cantidad > 1 && (
        <p className="text-2xs lg:text-xs font-semibold text-left text-gdt-gray-4 mt-[11px] lg:mt-5">
          {!isTickets
            ? `VALOR PIN $${formatNumberToLocale(
                Math.round(product.precio / product.cantidad)
              )}`
            : '5 PINES'}
        </p>
      )}
    </Card>
  );
};
